import { 
  Action, 
  OperationType, 
  Position, 
  WarningType 
} from '../dispatcher/Types';

export const clearUploadPanel: Action = [{
  data: {
    data: []
  },
  type: OperationType.data
}, {
  moduleId: '{uploadPanelModuleId}',
  evaluate: true,
  executeType: 'visible',
  moduleName: 'UploadPanel',
  args: ['data', 'data'],
  name: 'setGridConfig'
}, {
  moduleId: '{uploadPanelModuleId}',
  evaluate: true,
  moduleName: 'UploadPanel',
  name: 'setGridData',
  args: ['data'],
  type: OperationType.addOperationData
}];

export const cancelSingeUpload: Action = [{
  data: {
    template: {
      bind: {
        cancelRequestForFile: '{cancelRequestForFile}',
        cancelRequestForUploadGroup: '{cancelRequestForUploadGroup}'
      }
    }
  },
  type: OperationType.cancelRequest
}, {
  name: 'clearUploadPanel',
  type: OperationType.action
}];

export const fileUploadDisabledWarning: Action = [{
  className: 'sm info',
  text: 'UploadDisabled.text',
  title: 'UploadDisabled.title',
  items: [{
    close: true,
    btnName: 'UploadDisabled.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }],
  warningType: WarningType.info,
  type: OperationType.warning
}];

export const fileUploadDisabledWarningByInstructions: Action = [{
  className: 'sm info',
  text: 'UploadDisabledByInstructions.text',
  title: 'UploadDisabledByInstructions.title',
  items: [{
    close: true,
    btnName: 'UploadDisabledByInstructions.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
    operations: [{
      name: 'clearUploadPanel',
      type: OperationType.action
    }]
  }],
  placeholders: {
    template: {
      bind: {
        instructions: '{instructions}'
      }
    }
  },
  warningType: WarningType.info,
  type: OperationType.warning
}];

export const invalidFileDropWarning: Action = [{
  className: 'sm info',
  text: 'InvalidUpload.text',
  title: 'InvalidUpload.title',
  items: [{
    close: true,
    btnName: 'InvalidUpload.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }],
  warningType: WarningType.info,
  type: OperationType.warning
}];

export const dropUploadFiles: Action = [{
  moduleId: '{uploadPanelModuleId}',
  evaluate: true,
  executeType: 'visible',
  moduleName: 'UploadPanel',
  args: ['droppedFiles'],
  name: 'setDroppedFiles'
}, {
  evaluate: true,
  uniqueParameter: '{uniqueParameter}',
  mappingName: '{mappingName}',
  uploadCondition: '{uploadCondition}',
  handleErrorStatuses: '{handleErrorStatuses}',
  initialData: {
    template: {
      bind: {
        concurrently: '{concurrently}',
        method: '{prepareRequest.method}',
        url: '{prepareRequest.url}'
      }
    }
  },
  data: {
    template: {
      bind: {
        concurrently: '{concurrently}',
        method: '{request.method}',
        url: '{request.url}'
      }
    }
  },
  afterInitialRequest: [{
    moduleId: '{uploadPanelModuleId}',
    evaluate: true,
    executeType: 'visible',
    moduleName: 'UploadPanel',
    args: ['{mappingName_INITIAL}', 'droppedFiles'],
    name: 'setGridConfig'
  }],
  operations: [{
    moduleId: '{uploadPanelModuleId}',
    evaluate: true,
    moduleName: 'UploadPanel',
    name: 'setGridData',
    args: ['{mappingName}'],
    type: OperationType.addOperationData
  }],
  progressOperations: [{
    moduleId: '{uploadPanelModuleId}',
    evaluate: true,
    executeType: 'visible',
    moduleName: 'UploadPanel',
    args: ['progresses'],
    name: 'updateFileUploadProgresses'
  }],
  type: OperationType.upload
}];

export const dropUploadFilesWithoutPrepare: Action = [{
  moduleId: '{uploadPanelModuleId}',
  evaluate: true,
  executeType: 'visible',
  moduleName: 'UploadPanel',
  args: ['droppedFiles'],
  name: 'setDroppedFiles'
}, {
  evaluate: true,
  uniqueParameter: '{uniqueParameter}',
  mappingName: '{mappingName}',
  uploadCondition: '{uploadCondition}',
  handleErrorStatuses: '{handleErrorStatuses}',
  data: {
    template: {
      bind: {
        concurrently: '{concurrently}',
        method: '{request.method}',
        url: '{request.url}'
      }
    }
  },
  operations: [{
    moduleId: '{uploadPanelModuleId}',
    evaluate: true,
    moduleName: 'UploadPanel',
    name: 'setGridData',
    args: ['{mappingName}'],
    type: OperationType.addOperationData
  }],
  progressOperations: [{
    moduleId: '{uploadPanelModuleId}',
    evaluate: true,
    executeType: 'visible',
    moduleName: 'UploadPanel',
    args: ['progresses'],
    name: 'updateFileUploadProgresses'
  }],
  type: OperationType.upload
}];

export const uploadFilesRequestSimple: Action = [{
  data: {
    template: {
      bind: {
        concurrently: '{concurrently}',
        method: '{request.method}',
        url: '{request.url}'
      },
      isUpload: true
    }
  },
  type: OperationType.request
}, {
  moduleId: '{uploadPanelModuleId}',
  evaluate: true,
  moduleName: 'UploadPanel',
  name: 'setGridData',
  args: ['responseObject'],
  type: OperationType.addOperationData
}];
